import hucffLogo from "./hucff.png";
import ipsgLogo from "./ipsg.png";
import hospitalDeAmorLogo from "./hospital_de_amor.jpg";

const testimonialsIndex = [
  {
    logo: hucffLogo,
    text: "HucffTestimonialText",
    person: `Sergio Augusto Lopes de Souza`,
    personTitle: "HucffTestimonialPersonTitle",
  },
  {
    logo: ipsgLogo,
    text: "IpsgTestimonialText",
    person: `Sylvia Thomas, MD, PhD`,
    personTitle: "IpsgTestimonialPersonTitle",
  },
  {
    logo: hospitalDeAmorLogo,
    text: "WilsonFurlanTestimonialText",
    person: `Dr Wilson Furlan`,
    personTitle: "WilsonFurlanTestimonialPersonTitle",
  },
  {
    logo: hospitalDeAmorLogo,
    text: "ViniciusSantosTestimonialText",
    person: `MSc Vinicius Santos`,
    personTitle: "ViniciusSantosTestimonialPersonTitle",
  },
];

export default testimonialsIndex;

